<template>
  <div>
    <cc-collapse :title="$t('ct-general-settings')">
      <cc-image-component ref="image-src"></cc-image-component>
      <div class="form-group">
        <label for="alt-image">{{ $t('ct-alt-image') }}</label>
        <input id="alt-image" type="text" class="form-control" v-model="config.alt" @keyup="save()" @change="save()">
      </div>
      <div class="form-group">
        <label for="title-image">{{ $t('ct-title-image') }}</label>
        <input id="title-image" type="text" class="form-control" v-model="config.title" @keyup="save()"
               @change="save()">
      </div>
    </cc-collapse>

    <cc-collapse :title="$t('ct-sizes')">
      <cc-slider-component ref="widthConfig" :min="10"></cc-slider-component>
      <cc-slider-component ref="minWidthTabletConfig" :min="10"></cc-slider-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-opacity')">
      <cc-slider-component ref="opacity"></cc-slider-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-border')">
      <cc-border-component ref="border"></cc-border-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-border-radius')">
      <cc-border-radius-component ref="borderRadius"></cc-border-radius-component>
    </cc-collapse>

    <cc-collapse :title="$t('ct-animation')">
      <cc-animation ref="animation"></cc-animation>
    </cc-collapse>

    <cc-collapse :title="$t('ct-padding')" class="padding-mobile">
      <cc-padding ref="padding"></cc-padding>
    </cc-collapse>

    <cc-collapse :title="$t('ct-tag')">
      <cc-tag ref="tag"></cc-tag>
    </cc-collapse>

    <cc-collapse :title="$t('ct-layers')">
      <cc-z-index ref="z-index"></cc-z-index>
    </cc-collapse>

  </div>
</template>

<script>
export default {
  name: 'Image3DOptions',
  data() {
    return {
      config: {},
      callback: () => {
      }
    };
  },
  methods: {
    init(config, callback) {
      let vm = this;
      vm.config = _.clone(config);
      vm.callback = callback;

      this.$refs['widthConfig'].setValues({
        defaultValue: vm.config.width,
        defaultValueChecked: true,
        min: 10,
        max: 1920,
        canBeCheckbox: false,
        labelDesc: 'width',
        name: 'iconColor',
        callback: vm.setWidth
      });

      this.$refs['opacity'].setValues({
        defaultValue: vm.config.opacity * 100,
        defaultValueChecked: true,
        min: 1,
        max: 100,
        canBeCheckbox: false,
        labelDesc: 'opacity',
        name: 'opacity',
        callback: vm.setOpacity
      });

      this.$refs['minWidthTabletConfig'].setValues({
        defaultValue: vm.config.maxWidth,
        defaultValueChecked: true,
        min: 10,
        max: 1920,
        canBeCheckbox: false,
        labelDesc: 'max-width-tablet',
        name: 'iconColor',
        callback: vm.setMaxWidth
      });
      this.$refs['image-src'].setValues({
        defaultValue: vm.config.src,
        showOptions: false,
        defaultValueOrigin: '',
        defaultValueRepeat: '',
        defaultValueSize: '',
        defaultValueAttachment: '',
        defaultValuePosition: '',
        canExternal: true,
        canRemove: true,
        callback: vm.setImage
      });

      // border
      this.$refs['border'].setValues({
        defaultValue: vm.config.border,
        labelDesc: 'border',
        name: 'border',
        callback: vm.setBorder
      });
      this.$refs['borderRadius'].setValues({
        defaultValue: vm.config.borderRadius,
        labelDesc: 'borderRadius',
        name: 'borderRadius',
        callback: vm.setBorderRadius
      });

      // animation
      this.$refs['animation'].setValues({
        action: vm.config.animation.in.action,
        effect: vm.config.animation.in.effect,
        scroll: vm.config.animation.in.scroll,
        time: vm.config.animation.in.time,
        speed: vm.config.animation.in.speed,
        infinite: vm.config.animation.in.infinite,
        labelDesc: 'animate',
        name: 'animate',
        callback: vm.setAnimation
      }, null);

      // padding
      this.$refs['padding'].setValues({
        defaultTop: vm.config.paddingTop,
        defaultBottom: vm.config.paddingBottom,
        defaultLeft: vm.config.paddingLeft,
        defaultRight: vm.config.paddingRight,
        min: 0,
        max: 100,
        labelDesc: 'padding',
        callback: vm.setPadding
      });


      // tag
      this.$refs['tag'].setValues({tag: vm.config.tag, callback: vm.setTag});

      // z-index
      this.$refs['z-index'].setValues({defaultValue: vm.config.zIndex, callback: vm.setZIndex});
    },


    setOpacity(value) {
      this.config.opacity = value / 100;
      this.save();

    },
    setPadding(data) {
      this.config.paddingTop = `${data.paddingTop}px`;
      this.config.paddingBottom = `${data.paddingBottom}px`;
      this.config.paddingLeft = `${data.paddingLeft}px`;
      this.config.paddingRight = `${data.paddingRight}px`;
      this.save();
    },
    setBorder(data) {
      this.config.border = `${data.size}px ${data.style} ${data.color}`;
      this.save();
    },
    setBorderRadius(data) {
      this.config.borderRadius = data.value;
      this.save();
    },
    setWidth(value) {
      this.config.width = `${value}px`;
      this.save();
    },
    setMaxWidth(value) {
      this.config.maxWidth = `${value}px`;
      this.save();
    },
    setImage(data) {
      if (data.type === 'setImage') {
        this.config.src = data.src;
      }

      if (data.type === 'removeImage') {
        this.config.src = '';
      }
      this.save();
    },
    setAnimation(data) {
      this.config.animation.in = _.merge(this.config.animation.in, data);
      this.save();
    },
    setZIndex(value) {
      this.config.zIndex = value;
      this.save();
    },
    setTag(value) {
      this.config.tag = value;
      this.save();
    },
    save() {
      this.callback(this.config);
    }
  },
  beforeDestroy() {
    this.config = {};
    this.callback = () => {
    };
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Image3D/Options.vue